export default __webpack_public_path__ + "static/media/king_black.6c8cc8fa.svg";